/* @flow */

import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import TagButton from 'src/shared/ui/component/button/Tag/TagButton';
import TagRadio from 'src/shared/ui/component/button/Tag/TagRadio';
import TagLink from 'src/shared/ui/component/button/Tag/TagLink';

import KeywordTagLink from 'src/shared/components/domain/keyword/KeywordTagLink';

import styles from './TagGroup.style';

type ChildrenType = React.ChildrenArray<
  // eslint conflict with prettier
  // eslint-disable-next-line flowtype/generic-spacing
  React.Element<
    typeof TagButton | typeof TagRadio | typeof TagLink | typeof KeywordTagLink,
  >,
>;

type Props = {
  'aria-describedby'?: string,
  children: ChildrenType,
};

const useStyles = createUseThemeStyles(styles);

const TagGroup = ({
  'aria-describedby': ariaDescribedBy,
  children,
}: Props): React.Node => {
  const classes = useStyles();

  return (
    <ul className={classes.root} aria-describedby={ariaDescribedBy}>
      {React.Children.map(children, (child, index) => (
        <li key={index} className={classes.item}>
          {child}
        </li>
      ))}
    </ul>
  );
};

export default React.memo<Props>(TagGroup);
